















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import employeesRepository from '@/modules/employees/employeesRepository';
import Card from '@/components/default/Card.vue';
import Datagrid from '@/components/default/Datagrid.vue';

import { DxSwitch } from 'devextreme-vue/switch';

import SaveBar from '@/modules/shared/savebar/SaveBar.vue';

import notificationService from '@/services/notificationService';
import isEqual from 'lodash/isEqual';

@Component({
  components: {
    Card,
    SaveBar,
    Datagrid,
    DxSwitch,
  },
})
export default class EmployeeRoles extends Vue {
  @Prop({required: true})
  private id!: string;

  private loading: boolean = false;
  private saving: boolean = false;
  private initialised: boolean = false;
  private roles: IEmployeeRoles = {
    admin: false,
    administration: false,
    calculator: false,
    qualityGuard: false,
    projectCoordinator: false,
    hr: false,
  };
  private value: IEmployeeRoles = {
    admin: false,
    administration: false,
    calculator: false,
    qualityGuard: false,
    projectCoordinator: false,
    hr: false,
  };

  private async mounted() {
    await this.loadData();
  }

  private async loadData() {
    try {
      this.loading = true;
      this.roles = (await employeesRepository.getRoles(this.id)).data;
      Object.assign(this.value, this.roles);
      setTimeout(() => {
        this.initialised = true;
      }, 200);
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.loading = false;
    }
  }

  private async save() {
    try {
      this.saving = true;
      await employeesRepository.updateRoles(this.id, this.value);
      Object.assign(this.roles, this.value);
      notificationService.saved();
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.saving = false;
    }
  }

  get dirty(): boolean {
    return !isEqual(this.value, this.roles);
  }
}
